import { Dispatchers_getInstanceitgtkvqfcnx3 as Dispatchers_getInstance } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Dispatchers.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { delay1diib1rb84y4j as delay } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import {
  CoroutineScopelux7s7zphw7e as CoroutineScope,
  CoroutineScopefcb5f5dwqcas as CoroutineScope_0,
} from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { SupervisorJobythnfxkr3jxc as SupervisorJob } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Supervisor.mjs';
import { AbstractCoroutineContextElement2rpehg0hv5szw as AbstractCoroutineContextElement } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContextImpl.mjs';
import { Key_instance2ye2t23iqghop as Key_instance } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineExceptionHandler.mjs';
import {
  Companion_getInstancec4l82qvpwbuq as Companion_getInstance,
  Reactive1jy75v4li6ldv as Reactive,
} from './coreInterfaces.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { Element2gr7ezmxqaln7 as Element } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContext.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { BaseListenable1u3g4s45l82o6 as BaseListenable } from './abstracts.mjs';
import { ReactiveContextSuspending39biijty1bpc5 as ReactiveContextSuspending } from '../context/ReactiveContextSuspending.mjs';
import { Duration5ynfiptaqcrg as Duration } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function rememberSuspending(coroutineContext, useLastWhileLoading, deactivationDelay, action) {
  coroutineContext = coroutineContext === VOID ? Dispatchers_getInstance().yac_1 : coroutineContext;
  useLastWhileLoading = useLastWhileLoading === VOID ? false : useLastWhileLoading;
  deactivationDelay = deactivationDelay === VOID ? null : deactivationDelay;
  return RememberSuspending().fam(coroutineContext, useLastWhileLoading, deactivationDelay, action);
}
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  var tmp = $this.oao_1.ka3($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  $this.pao_1.bam_1.aaj();
  var tmp_0 = $this.pao_1;
  tmp_0.dam_1 = $this.pao_1.bam_1.vah(() => {
    $this.pao_1.mal();
    return Unit_instance;
  });
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $this$launch, $completion) {
  var tmp = delay($this.qao_1.xal_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = $this.qao_1;
  var tmp_1 = CoroutineScope($this.qao_1.wal_1);
  tmp_0.eam_1 = launch(tmp_1, VOID, VOID, RememberSuspending$deactivate$slambda$slambda_0($this.qao_1));
  $this.qao_1.cam_1 = null;
  return Unit_instance;
}
var RememberSuspending$deactivate$slambda$slambdaClass;
function RememberSuspending$deactivate$slambda$slambda() {
  if (RememberSuspending$deactivate$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.rao_1 = this$0;
      }
      yah($this$launch, $completion) {
        shutdown(this.rao_1);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope_0()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    RememberSuspending$deactivate$slambda$slambdaClass = $;
  }
  return RememberSuspending$deactivate$slambda$slambdaClass;
}
function RememberSuspending$deactivate$slambda$slambda_0(this$0) {
  var i = new (RememberSuspending$deactivate$slambda$slambda())(this$0);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function shutdown($this) {
  var tmp0_safe_receiver = $this.dam_1;
  if (tmp0_safe_receiver == null)
    null;
  else
    tmp0_safe_receiver();
  $this.dam_1 = null;
  $this.bam_1.nai();
  $this.zal_1.oa3();
  $this.zal_1 = SupervisorJob();
  $this.eam_1 = null;
}
var RememberSuspending$restOfContext$$inlined$CoroutineExceptionHandler$1Class;
function RememberSuspending$restOfContext$$inlined$CoroutineExceptionHandler$1() {
  if (RememberSuspending$restOfContext$$inlined$CoroutineExceptionHandler$1Class === VOID) {
    class $ extends AbstractCoroutineContextElement() {
      constructor() {
        super(Key_instance);
      }
      ya8(context, exception) {
        if (!(exception instanceof CancellationException())) {
          Companion_getInstance().zaj_1(exception);
        }
        return Unit_instance;
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [AbstractCoroutineContextElement(), Element()]);
    RememberSuspending$restOfContext$$inlined$CoroutineExceptionHandler$1Class = $;
  }
  return RememberSuspending$restOfContext$$inlined$CoroutineExceptionHandler$1Class;
}
var RememberSuspending$scope$slambdaClass;
function RememberSuspending$scope$slambda() {
  if (RememberSuspending$scope$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.tao_1 = this$0;
      }
      uao($completion) {
        return this.tao_1.yal_1(this.tao_1, $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    RememberSuspending$scope$slambdaClass = $;
  }
  return RememberSuspending$scope$slambdaClass;
}
function RememberSuspending$scope$slambda_0(this$0) {
  var i = new (RememberSuspending$scope$slambda())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var RememberSuspending$activate$slambdaClass;
function RememberSuspending$activate$slambda() {
  if (RememberSuspending$activate$slambdaClass === VOID) {
    class $ {
      constructor($it, this$0) {
        this.oao_1 = $it;
        this.pao_1 = this$0;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope_0()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    RememberSuspending$activate$slambdaClass = $;
  }
  return RememberSuspending$activate$slambdaClass;
}
function RememberSuspending$activate$slambda_0($it, this$0) {
  var i = new (RememberSuspending$activate$slambda())($it, this$0);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var RememberSuspending$deactivate$slambdaClass;
function RememberSuspending$deactivate$slambda() {
  if (RememberSuspending$deactivate$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.qao_1 = this$0;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope_0()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    RememberSuspending$deactivate$slambdaClass = $;
  }
  return RememberSuspending$deactivate$slambdaClass;
}
function RememberSuspending$deactivate$slambda_0(this$0) {
  var i = new (RememberSuspending$deactivate$slambda())(this$0);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var RememberSuspendingClass;
function RememberSuspending() {
  if (RememberSuspendingClass === VOID) {
    class $ extends BaseListenable() {
      static fam(incomingCoroutineContext, useLastWhileLoading, deactivationDelay, action) {
        incomingCoroutineContext = incomingCoroutineContext === VOID ? Dispatchers_getInstance().yac_1 : incomingCoroutineContext;
        useLastWhileLoading = useLastWhileLoading === VOID ? false : useLastWhileLoading;
        deactivationDelay = deactivationDelay === VOID ? null : deactivationDelay;
        var $this = this.uam();
        $this.wal_1 = incomingCoroutineContext;
        $this.xal_1 = deactivationDelay;
        $this.yal_1 = action;
        $this.zal_1 = SupervisorJob();
        var tmp = $this;
        // Inline function 'kotlinx.coroutines.CoroutineExceptionHandler' call
        var tmp$ret$0 = new (RememberSuspending$restOfContext$$inlined$CoroutineExceptionHandler$1())();
        tmp.aam_1 = $this.wal_1.gp(tmp$ret$0);
        var tmp_0 = $this;
        tmp_0.bam_1 = new (ReactiveContextSuspending())($this, useLastWhileLoading, VOID, RememberSuspending$scope$slambda_0($this));
        $this.cam_1 = null;
        $this.dam_1 = null;
        $this.eam_1 = null;
        return $this;
      }
      ga2() {
        return this.aam_1.gp(this.zal_1);
      }
      sah() {
        if (!this.bam_1.taj_1) {
          this.bam_1.baj();
        }
        return this.bam_1.sah();
      }
      kal() {
        if (!(this.cam_1 == null)) {
          var tmp0_safe_receiver = this.cam_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.oa3();
          }
          this.cam_1 = null;
          return Unit_instance;
        }
        var tmp1_safe_receiver = this.eam_1;
        var tmp;
        if (tmp1_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          var tmp_0 = CoroutineScope(this.wal_1);
          tmp = launch(tmp_0, VOID, VOID, RememberSuspending$activate$slambda_0(tmp1_safe_receiver, this));
        }
        if (tmp == null) {
          // Inline function 'kotlin.run' call
          var $this$run = this;
          $this$run.bam_1.aaj();
          var tmp_1 = $this$run;
          tmp_1.dam_1 = $this$run.bam_1.vah(() => {
            $this$run.mal();
            return Unit_instance;
          });
        }
      }
      lal() {
        var tmp = this.xal_1;
        if (!((tmp == null ? null : new (Duration())(tmp)) == null)) {
          if (!(this.cam_1 == null))
            return Unit_instance;
          var tmp_0 = this;
          tmp_0.cam_1 = launch(this, VOID, VOID, RememberSuspending$deactivate$slambda_0(this));
        } else {
          shutdown(this);
        }
      }
    }
    initMetadataForClass($, 'RememberSuspending', VOID, VOID, [Reactive(), CoroutineScope_0(), BaseListenable()]);
    RememberSuspendingClass = $;
  }
  return RememberSuspendingClass;
}
//region block: exports
export {
  RememberSuspending as RememberSuspending3811d1qplzllg,
  rememberSuspending as rememberSuspending3qo0upgbry9b,
};
//endregion

//# sourceMappingURL=RememberSuspending.mjs.map
